import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store'
// import Vant from 'vant';
import { Button, Popup, Progress, Loading, CountDown } from 'vant';
import 'vant/lib/index.css';
import i18n from './i18n.js';
import appConfig from '@/common/config.js';

Vue.use(Button);
Vue.use(Popup);
Vue.use(Progress);
Vue.use(Loading);
Vue.use(CountDown);
// Vue.use(Vant);
// Vue.use(router);

Vue.prototype.$appConfig = appConfig;

Vue.config.productionTip = false

const getQueryString = function (name) {
  const url = new URL(window.location.href);
  return new URLSearchParams(url.hash.split('?')[1]).get(name);
}

Vue.prototype.$getQueryString = getQueryString;


import {
  formatNumber
} from "@/utils/index.js"

Vue.prototype.$formatNumber = formatNumber;


import {
  withRetry,
  defaultErrorFilter,
  NonRetryableError,
  MaxRetriesError
} from "@/utils/retryUtil.js"
// console.log(withRetry)
Vue.prototype.$withRetry = function (fn) {
  return withRetry(fn);
}

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
